module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bPiXa"))).then(() => parcelRequire('1iHdE'));